import { render, staticRenderFns } from "./target.vue?vue&type=template&id=25eb0498&scoped=true"
import script from "./target.vue?vue&type=script&lang=js"
export * from "./target.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb0498",
  null
  
)

export default component.exports